const stateManager = require('../state/stateManager');
const orgSelectors = require('../state/stateSelectors/orgSelectors');
const currentOrgNodeSelectors = require('../state/stateSelectors/currentOrgNodeSelectors');

const domainConstants = require('../domain/constants');

module.exports.getCompleteName = (staff)=> (`${staff.firstName} ${staff.lastName}`).trim()

module.exports.getProperty = (propertyId)=> orgSelectors.selectProperties().find(p => p.id === propertyId)

module.exports.isCentralKitchenPropertySelected = ()=> 
{
    if (!currentOrgNodeSelectors.isCurrentPropertySelected())
        return false;

    return currentOrgNodeSelectors.selectCurrentProperty().type === domainConstants.serviceContextTypes.centralKitchen;
}

module.exports.getApplicationMode = ()=> stateManager.getStore().getState().applicationMode
